/// <amd-module name="SuiteCommerce.StockNotifications.Utils"/>
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
define("SuiteCommerce.StockNotifications.Utils", ["require", "exports", "underscore"], function (require, exports, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function stringFormat(text) {
        var continuationText = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            continuationText[_i - 1] = arguments[_i];
        }
        return text.replace(/\$\((\d+)\)/g, function (match, number) {
            if (typeof continuationText[number] !== 'undefined') {
                return continuationText[number].toString();
            }
            return match.toString();
        });
    }
    function isUrlAbsolute(url) {
        return /^https?:\/\//.test(url);
    }
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.getAbsoluteUrlOfNonManagedResources = function (file) {
            return Utils.getAbsoluteUrl(file);
        };
        Utils.getThemeAbsoluteUrlOfNonManagedResources = function (defaultValue, file) {
            if (!file) {
                file = '';
                if (SC.ENVIRONMENT.isExtended) {
                    file = SC.ENVIRONMENT.themeAssetsPath || '';
                }
                else if (SC.ENVIRONMENT.BuildTimeInf && SC.ENVIRONMENT.BuildTimeInf.isSCLite) {
                    if (SC.CONFIGURATION.unmanagedResourcesFolderName) {
                        file = "site/" + SC.CONFIGURATION.unmanagedResourcesFolderName + "/";
                    }
                    else {
                        file = 'default/';
                    }
                }
                file += defaultValue;
            }
            return Utils.getAbsoluteUrl(file);
        };
        Utils.translate = function (text) {
            var continuationText = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                continuationText[_i - 1] = arguments[_i];
            }
            if (!text) {
                return '';
            }
            // Turns the arguments object into an array
            var parameters = [];
            // Checks the translation table
            var result = SC.Translations && SC.Translations[text] ? SC.Translations[text] : text;
            if (continuationText && continuationText.length && result) {
                var firstParameter = continuationText[0];
                if (_.isArray(firstParameter) && firstParameter.length) {
                    parameters = firstParameter;
                }
                else {
                    parameters = _.map(continuationText, function (param) {
                        return _.escape(param);
                    });
                }
            }
            result = stringFormat.apply(void 0, __spreadArrays([result], parameters));
            return result;
        };
        Utils.getAbsoluteUrl = function (file) {
            if (file === void 0) { file = ''; }
            var base_url = (SC && SC.ENVIRONMENT && SC.ENVIRONMENT.baseUrl) || '';
            var fileReplace = file;
            if (base_url && !isUrlAbsolute(fileReplace)) {
                return base_url.replace('{{file}}', fileReplace);
            }
            return file;
        };
        Utils.imageFlatten = function (images) {
            var _this = this;
            var result = [];
            if ('url' in images && 'altimagetext' in images) {
                return [images];
            }
            Object.getOwnPropertyNames(images).forEach(function (key) {
                if (_.isArray(images[key])) {
                    result.push(images[key]);
                }
                else {
                    result.push(_this.imageFlatten(images[key]));
                }
            });
            return _.flatten(result);
        };
        Utils.addParamsToUrl = function (baseUrl, params, avoidDoubleRedirect) {
            if (avoidDoubleRedirect) {
                var newParams_1 = {};
                _.each(params, function (paramValue, paramKey) {
                    newParams_1["__" + paramKey] = paramValue;
                });
                params = newParams_1;
            }
            if (baseUrl && !_.isEmpty(params)) {
                var paramString = jQuery.param(params);
                var joinString = baseUrl.indexOf('?') !== -1 ? '&' : '?';
                return baseUrl + joinString + paramString;
            }
            return baseUrl;
        };
        Utils.parseUrlOptions = function (optionsString) {
            var urlOption = optionsString || '';
            if (urlOption && urlOption.indexOf('?') !== -1) {
                urlOption = _.last(urlOption.split('?'));
            }
            if (urlOption && urlOption.indexOf('#') !== -1) {
                urlOption = _.first(urlOption.split('#'));
            }
            var options = {};
            if (urlOption && urlOption.length > 0) {
                var tokens = urlOption.split(/&/g);
                var currentToken = [];
                while (tokens.length > 0) {
                    var firstElement = tokens.shift();
                    if (firstElement) {
                        currentToken = firstElement.split(/=/g);
                    }
                    if (currentToken && currentToken[0].length !== 0) {
                        options[currentToken[0]] = this.getDecodedURLParameter(currentToken[1]);
                    }
                }
            }
            return options;
        };
        Utils.getDecodedURLParameter = function (urlParameter) {
            if (urlParameter === void 0) { urlParameter = ''; }
            var position;
            var temporal;
            for (temporal = ''; (position = urlParameter.indexOf('%')) >= 0; urlParameter = urlParameter.substring(position + 3)) {
                temporal += urlParameter.substring(0, position);
                var extract = urlParameter.substring(position, position + 3);
                try {
                    temporal += decodeURIComponent(extract);
                }
                catch (e) {
                    temporal += extract;
                }
            }
            return temporal + urlParameter;
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
